/** Road-facing stand point for click-to-walk building interactions. */

export function buildingInteractStandPoint(options: {
  footLeft: number;
  footTop: number;
  footSpan: number;
  spineWx: number;
  spineWy: number;
  /** Extra px beyond footprint edge toward the sidewalk (default ~0.35 tile). */
  padPx?: number;
}): { wx: number; wy: number } {
  const { footLeft, footTop, footSpan, spineWx, spineWy, padPx = 22 } = options;
  const fcx = footLeft + footSpan / 2;
  const fcy = footTop + footSpan / 2;
  const dx = spineWx - fcx;
  const dy = spineWy - fcy;
  const dist = Math.hypot(dx, dy);
  if (dist < 1) return { wx: fcx, wy: fcy };
  const outward = footSpan / 2 + padPx;
  return {
    wx: fcx + (dx / dist) * outward,
    wy: fcy + (dy / dist) * outward,
  };
}
